import { render } from "./Courseware.vue?vue&type=template&id=f581fa48&scoped=true&ts=true"
import script from "./Courseware.vue?vue&type=script&lang=tsx"
export * from "./Courseware.vue?vue&type=script&lang=tsx"

import "./Courseware.vue?vue&type=style&index=0&id=f581fa48&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f581fa48"]])

export default __exports__